import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pastTwoWeeksButtonText: {
		id: 'software-deployments.date-filter.past-two-weeks-button-text',
		defaultMessage: '2 Weeks',
		description: 'Button text for selecting the past 2 weeks option',
	},
	pastMonthButtonText: {
		id: 'software-deployments.date-filter.past-month-button-text',
		defaultMessage: 'Month',
		description: 'Button text for selecting the past month option',
	},
	pastQuarterButtonText: {
		id: 'software-deployments.date-filter.past-quarter-button-text',
		defaultMessage: 'Quarter',
		description: 'Button text for selecting the past quarter option',
	},
	pastYearButtonText: {
		id: 'software-deployments.date-filter.past-year-button-text',
		defaultMessage: 'Year',
		description: 'Button text for selecting the past year option',
	},
	dateFilterIcon: {
		id: 'software-deployments.date-filter.date-filter-icon',
		defaultMessage: 'Date Filter Icon',
		description: 'Label for date filter calendar icon',
	},
	pastTwoWeeksTooltipText: {
		id: 'software-deployments.date-filter.past-two-weeks-tooltip-text',
		defaultMessage: 'Dates filtered to the past 2 weeks',
		description:
			'Tooltip text shown when hovering over the date filter button when the past two weeks option is selected',
	},
	pastMonthTooltipText: {
		id: 'software-deployments.date-filter.past-month-tooltip-text',
		defaultMessage: 'Dates filtered to the past month',
		description:
			'Tooltip text shown when hovering over the date filter button when the past month option is selected',
	},
	pastQuarterTooltipText: {
		id: 'software-deployments.date-filter.past-quarter-tooltip-text',
		defaultMessage: 'Dates filtered to the past quarter',
		description:
			'Tooltip text shown when hovering over the date filter button when the past quarter option is selected',
	},
	pastYearTooltipText: {
		id: 'software-deployments.date-filter.past-year-tooltip-text',
		defaultMessage: 'Dates filtered to the past year',
		description:
			'Tooltip text shown when hovering over the date filter button when the past year option is selected',
	},
	customRangeTooltipText: {
		id: 'software-deployments.date-filter.custom-range-tooltip-text',
		defaultMessage: 'Dates filtered from {startDate} - {endDate}',
		description:
			'Tooltip text shown when hovering over the date filter button when the custom range option is selected. Dates shown in message will be in YYYY/MM/DD - YYYY/MM/DD format and depend on the current user selection',
	},
	modalHeading: {
		id: 'software-deployments.date-filter.modal-heading',
		defaultMessage: 'Select custom date range',
		description:
			'Heading of the custom date range modal, where users can select their custom date range',
	},
});
